export default __webpack_public_path__ + "static/media/contact-us-image.4b0d626f.jpg";